// utils.js
export function calculateProgressAndDays(startDate, endDate) {
  const today = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);

  const msInDay = 1000 * 60 * 60 * 24;
  const timeRemaining = end.getTime() - today.getTime();
  const daysRemaining = Math.ceil(timeRemaining / msInDay);

  const totalDuration = end.getTime() - start.getTime();
  const elapsedDuration = today.getTime() - start.getTime();
  let progressPercentage = 0;
  if (totalDuration > 0) {
    progressPercentage = Math.min(100, Math.max(0, (elapsedDuration / totalDuration) * 100));
  } else if (elapsedDuration >= 0) {
    progressPercentage = 100;
  }

  let status = 'Occupato';
  if (daysRemaining <= 0) {
    status = 'Disponibile';
  } else if (daysRemaining <= 21) {
    status = 'Presto Disponibile';
  }

  return { status, progress: progressPercentage, daysRemaining: Math.max(daysRemaining, 0) };
}

// opzionale: se la usi altrove
export function getProgressBarCustomColor(progress) {
  if (progress >= 90) return '#8BC34A';
  if (progress >= 50) return '#FFC107';
  return '#F44336';
}
